import React, { useState } from "react";
import { useTheme } from "../config/ThemeContext";
import apiClient from "../services/apiClient";

function RecomputeMatch() {
  const colors = useTheme();
  const [matchId, setMatchId] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleRecompute = async () => {
    if (!matchId) return;
    setLoading(true);
    setResult(null);
    setError(null);
    try {
      const res = await apiClient.post(`/api/matches/recompute/${matchId}`);
      setResult(res.data);
    } catch (err) {
      setError(err.response?.data || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6 bg-white rounded shadow mt-6">
      <h1 className={`text-2xl font-bold mb-4 ${colors.neutral.text}`}>🔁 Recompute MatchStats</h1>
      <div className="flex items-center space-x-2 mb-4">
        <input
          type="number"
          value={matchId}
          onChange={(e) => setMatchId(e.target.value)}
          placeholder="Enter Match ID"
          className="border px-3 py-2 rounded w-full"
        />
        <button
          onClick={handleRecompute}
          className={colors.buttons.primary}
          disabled={loading}
        >
          {loading ? "Recomputing..." : "Recompute"}
        </button>
      </div>
      {result && (
        <pre className="bg-green-50 p-4 rounded border text-sm text-green-800 whitespace-pre-wrap">
          ✅ Success: {JSON.stringify(result, null, 2)}
        </pre>
      )}
      {error && (
        <pre className="bg-red-50 p-4 rounded border text-sm text-red-800 whitespace-pre-wrap">
          ❌ Error: {typeof error === "string" ? error : JSON.stringify(error, null, 2)}
        </pre>
      )}
    </div>
  );
}

export default RecomputeMatch;
